<div class="flex flex-col items-center justify-center flex-1 h-full patternBG">
  <div class="flex flex-col items-center justify-center gap-5 text-center p-4">
    <div class="flex items-center gap-3 bg-yellow-50 border border-yellow-300 text-yellow-700 p-4 rounded-md shadow-sm">
      <i class="fas fa-exclamation-circle text-yellow-500 text-xl"></i>
      <span class="text-md">{{ ('error404.' + error) | translate }}</span>
    </div>
  </div>
</div>
